import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import A1 from '../assets/gallery/A1.jpg';
import A2 from '../assets/gallery/A2.jpg';
import A3 from '../assets/gallery/A3.jpg';
import A5 from '../assets/gallery/A5.jpg';
import A6 from '../assets/gallery/A6.jpg';
import A7 from '../assets/gallery/A7.jpg'; 
import A8 from '../assets/gallery/A8.jpg';
import B1 from '../assets/gallery/B1.jpg';
import B3 from '../assets/gallery/B3.jpg';
import B4 from '../assets/gallery/B4.jpg';
import B5 from '../assets/gallery/B5.jpg';
import C1 from '../assets/gallery/C1.jpg';
import C2 from '../assets/gallery/C2.jpg';
import C3 from '../assets/gallery/C3.jpg';
import C4 from '../assets/gallery/C4.jpg';
import C5 from '../assets/gallery/C5.jpg';
import C6 from '../assets/gallery/C6.jpg';
import C7 from '../assets/gallery/C7.jpg';
import C8 from '../assets/gallery/C8.jpg';

import './css/MoveImage.css';

// Keyframe animations (unchanged)
const moveLeft = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const moveRight = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(100%); }
`;

// Styled components (unchanged)
const ImageWrapper = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: auto;
  position: relative;
`;

const ImageChainLeft = styled.div`
  display: flex;
  animation: ${moveLeft} 20s linear infinite;
  width: calc(100% * 2); /* Twice the width to ensure smooth loop */
`;

const ImageChainRight = styled.div`
  display: flex;
  animation: ${moveRight} 50s linear infinite;
  width: calc(100% * 2); /* Twice the width to ensure smooth loop */
  flex-direction: row-reverse; /* Reverse the direction of images for rightward scrolling effect */
`;

const Image = styled.img`
  width: 20%; /* Each image takes up 20% of the wrapper's width (5 images) */
  flex-shrink: 0;
`;

// MoveImage component
const MoveImage = () => {
  const moveContainerRef = useRef(null);

  const handleMouseWheel = (event) => {
    if (moveContainerRef.current) {
      moveContainerRef.current.scrollLeft += event.deltaY; // Scroll left/right based on mouse wheel movement
      event.preventDefault(); // Prevent default scrolling
    }
  };

  return (
    <div className='AImageMove' onWheel={handleMouseWheel} ref={moveContainerRef}>
      <div className='ImageMove'>
      <ImageWrapper>
          <ImageChainLeft>
            {/* Images */}
            <Image style={{ padding: '10px' }} src={A1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={A2} alt="Image 2" />
            <Image style={{ padding: '10px' }} src={A3} alt="Image 3" />
           
            <Image style={{ padding: '10px' }} src={A5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={A6} alt="Image 6" />
            <Image style={{ padding: '10px' }} src={A7} alt="Image 7" />
            <Image style={{ padding: '10px' }} src={A8} alt="Image 8" />
            {/* Duplicate images for smooth looping */}
            <Image style={{ padding: '10px' }} src={A1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={A2} alt="Image 2" />
            <Image style={{ padding: '10px' }} src={A3} alt="Image 3" />
            <Image style={{ padding: '10px' }} src={A5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={A6} alt="Image 6" />
            <Image style={{ padding: '10px' }} src={A7} alt="Image 7" />
            <Image style={{ padding: '10px' }} src={A8} alt="Image 8" />
          </ImageChainLeft>
        </ImageWrapper>

        <ImageWrapper>
          <ImageChainRight>
            {/* Images */}
            <Image style={{ padding: '10px' }} src={B1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={B3} alt="Image 3" />
            <Image style={{ padding: '10px' }} src={B4} alt="Image 4" />
            <Image style={{ padding: '10px' }} src={B5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={B1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={B3} alt="Image 3" />
            {/* Duplicate images for smooth looping */}
            <Image style={{ padding: '10px' }} src={B1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={B3} alt="Image 3" />
            <Image style={{ padding: '10px' }} src={B4} alt="Image 4" />
            <Image style={{ padding: '10px' }} src={B5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={B1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={B3} alt="Image 3" />
          </ImageChainRight>
        </ImageWrapper>

        <ImageWrapper>
          <ImageChainLeft>
            {/* Images */}
            <Image style={{ padding: '10px' }} src={C1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={C2} alt="Image 2" />
            <Image style={{ padding: '10px' }} src={C3} alt="Image 3" />
            <Image style={{ padding: '10px' }} src={C4} alt="Image 4" />
            <Image style={{ padding: '10px' }} src={C5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={C6} alt="Image 6" />
            <Image style={{ padding: '10px' }} src={C7} alt="Image 7" />
            <Image style={{ padding: '10px' }} src={C8} alt="Image 8" />
            {/* Duplicate images for smooth looping */}
            <Image style={{ padding: '10px' }} src={C1} alt="Image 1" />
            <Image style={{ padding: '10px' }} src={C2} alt="Image 2" />
            <Image style={{ padding: '10px' }} src={C3} alt="Image 3" />
            <Image style={{ padding: '10px' }} src={C4} alt="Image 4" />
            <Image style={{ padding: '10px' }} src={C5} alt="Image 5" />
            <Image style={{ padding: '10px' }} src={C6} alt="Image 6" />
            <Image style={{ padding: '10px' }} src={C7} alt="Image 7" />
            <Image style={{ padding: '10px' }} src={C8} alt="Image 8" />
          </ImageChainLeft>
        </ImageWrapper>
       
      </div>
    </div>
  );
};

export default MoveImage;
